'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var translation = require('@templafy/translation');
var hooks_useCombinedRefs = require('../hooks/useCombinedRefs.js');
var useDevelopmentEffect = require('./useDevelopmentEffect-DGG0KnB_.js');
var icons_IconLoading = require('../icons/IconLoading.js');
var utilities_combineClasses = require('./combineClasses-5P8GTQkg.js');
var utilities_createComponentNamespace = require('../utilities/createComponentNamespace.js');

require("../_assets/BaseButton-BZn-_Qzo.css");var styles = {"button":"BaseButton__oCwLpLYR2a__button","buttonAdornmentIcon":"BaseButton__oCwLpLYR2a__buttonAdornmentIcon","iconButton":"BaseButton__oCwLpLYR2a__iconButton","loadingIcon":"BaseButton__oCwLpLYR2a__loadingIcon"};

// eslint-disable-next-line react/display-name
const BaseButton = react.forwardRef(({ className, testId, variant = 'solid', action = 'secondary', theme = 'light', size = 'medium', alignToContent, loading, disabled, startAdornment, endAdornment, children, as, ...props }, ref) => {
    const translator = translation.useTranslator();
    const As = as ?? 'button';
    const buttonRef = react.useRef(null);
    const iconAdornments = [startAdornment, endAdornment].filter((element) => react.isValidElement(element) && element.type === ButtonAdornmentIcon);
    const hasSingleIcon = iconAdornments.length === 1 && !children;
    useDevelopmentEffect.useDevelopmentEffect(() => {
        if (!buttonRef.current || props['aria-hidden']) {
            return;
        }
        if (!buttonRef.current.textContent &&
            !props['aria-label'] &&
            !props['aria-labelledby']) {
            console.error('[BaseButton] A button must always have an accessible label. Provide either text content, the `aria-label` or the `aria-labelledby` attribute on the button element');
        }
    }, [children, props['aria-label']]);
    return (jsxRuntime.jsxs(As, { className: utilities_combineClasses.combineClasses(className, styles.button, hasSingleIcon && styles.iconButton), "data-variant": variant, "data-action": action, "data-theme": theme, "data-size": size, "data-testid": testId, "aria-label": loading ? translator.uiComponentsButtonLoadingLabel() : undefined, disabled: disabled || loading, "data-loading": loading, "data-align-to-content": alignToContent, ...(As === 'button' && {
            type: 'button',
        }), ...props, ref: hooks_useCombinedRefs.useCombinedRefs(ref, buttonRef), children: [jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [startAdornment, children && jsxRuntime.jsx("span", { "data-testid": "text", children: children }), endAdornment] }), loading && (jsxRuntime.jsx("span", { className: styles.loadingIcon, children: jsxRuntime.jsx(ButtonAdornmentIcon, { icon: icons_IconLoading.IconLoading }) }))] }));
});
const ButtonAdornmentIcon = react.forwardRef(({ icon: Icon, className, ...props }, ref) => Icon ? (jsxRuntime.jsx(Icon, { "aria-hidden": true, className: utilities_combineClasses.combineClasses(className, styles.buttonAdornmentIcon), ...props, ref: ref })) : null);
ButtonAdornmentIcon.displayName = 'ButtonAdornmentIcon';
const BaseButtonNamespace = utilities_createComponentNamespace.createComponentNamespace({
    component: BaseButton,
    componentList: { ButtonAdornmentIcon },
    namespace: 'BaseButton',
});
BaseButtonNamespace.displayName = 'BaseButton';

exports.BaseButtonNamespace = BaseButtonNamespace;
exports.ButtonAdornmentIcon = ButtonAdornmentIcon;
//# sourceMappingURL=BaseButton-DDcpn9-P.js.map
